// Generated by `pnpm generate` — do not edit.
import { createIcon } from '../create-icon';

export const YubikeyIcon = /* @__PURE__ */ createIcon(
  'yubikey',
  { fill: 'none', viewBox: '0 0 24 24' },
  [
    [
      'path',
      {
        fill: 'currentColor',
        d: 'M13.287 2.706a3 3 0 0 1 4.243 0l3.763 3.765a3 3 0 0 1 0 4.242l-7.74 7.741a3 3 0 0 1-3.39.595l-2.682 2.684a1.5 1.5 0 0 1-2.121 0L2.267 18.64a1.5 1.5 0 0 1 0-2.121l2.683-2.684a3 3 0 0 1 .595-3.388zM4.034 17.58l2.385 2.386 2.2-2.2-2.385-2.386zM16.115 4.12a1 1 0 0 0-1.414 0l-7.742 7.742a1 1 0 0 0 0 1.414l3.765 3.764a1 1 0 0 0 1.414 0L19.88 9.3a1 1 0 0 0 0-1.415zm-5.583 5.106a3 3 0 1 1 4.242 4.243 3 3 0 0 1-4.242-4.243m2.828 1.414a1 1 0 1 0-1.414 1.415 1 1 0 0 0 1.414-1.415m3.203-4.19a1 1 0 0 1 0 2h-.023a1 1 0 1 1 0-2z',
      },
    ],
  ]
);
